import { fromJS } from 'immutable'
import React from 'react'
import Button from '../../../common/button'
import Checkbox from '../../../common/checkbox'

/**
 * @param table
 * @param send
 */
class Players extends React.Component
{

    render()
    {
        const t = this.props.table
        const textSeparator = "  •  "

        const isPlayingSelf = t.get("ownId") != null && t.get("players").find(p => p.get("id") === t.get("ownId")).get("turnIdx") != null

        let players = {
            playing: [],
            idle: []
        }

        let blacklistedPlayers = t.getIn([ "spectatorConfig", "blacklistedPlayers" ]) || []

        t.get("players").forEach(player => {

            let description = "#" + (player.get("idx") + 1)
            if (player.get("lastDisconnected"))
            {
                description += textSeparator + Messages("table.disconnected")
            }
            if (player.get("id") === t.get("ownId"))
            {
                description += textSeparator + Messages("table.player.self")
            }
            const spectators = Array.from(t.get("spectators").filter(id => id == player.get("id")).keys())
            if (spectators.length)
            {
                description += textSeparator + Messages("table.spectate.spectators", spectators.length)
            }
            description += textSeparator + "∑ " + (t.getIn([ "latestRoundResult", "playerTotalPoints", player.get("id") ]) || 0)

            const isPlaying = player.get("turnIdx") != null
            const canSpectate = !blacklistedPlayers.includes(player.get("id"))

            const spectateToggle = isPlayingSelf && !isPlaying ? (
                <Checkbox
                    text={ Messages("table.spectate.spectate-toggle") }
                    checked={ canSpectate }
                    onChange={ () => {
                        if (canSpectate) {
                            blacklistedPlayers = blacklistedPlayers.concat([ player.get("id") ])
                        } else {
                            blacklistedPlayers = blacklistedPlayers.filter(p => p != player.get("id"))
                        }
                        this.props.send({
                            type: "SET_SPECTATOR_CONFIG",
                            blacklistedPlayers: blacklistedPlayers
                        })
                    } }
                />
            ) : null

            let isSpectating = t.get("spectatingId") == player.get("id")
            const spectateButton = !isPlayingSelf && t.get("playersSpectatable").includes(player.get("id")) ? (
                <Button
                    style={{ marginTop: 10 }}
                    text={ isSpectating ? Messages("table.spectate.stop-spectate") : Messages("table.spectate.spectate") }
                    onClick={ () => {
                        this.props.send({
                            type: "SPECTATE",
                            playerId: isSpectating ? null : player.get("id")
                        })
                    } }
                />
            ) : null;

            players[isPlaying ? "playing" : "idle"].push(
                <div key={ player.get("idx") } className={ "player player-" + (player.get("color").toLowerCase()) + ((spectateToggle || spectateButton) ? " large" : "") }>
                    <div>{ player.get("name") }</div>
                    <div>{ description }</div>
                    { spectateToggle }
                    { spectateButton }
                </div>
            )
        })

        let playerList = players.playing
        if (players.idle.length > 0) {
            playerList = [
                <div key="heading-playing" className="subheading">{ Messages("table.players.playing") }</div>
            ].concat(playerList).concat([
                <div key="heading-idle" className="subheading">{ Messages("table.players.not-playing") }</div>
            ]).concat(players.idle)
        }

        return (
            <div className="players">
                <div className="join-table">
                    <div>{ Messages("table.code") }</div>
                    <div className="code">{ t.get("code") }</div>
                </div>
                { playerList }
            </div>
        )
    }

}

export default Players
export { Players }